<div class="glass-card rounded-4 p-4 mb-4">

  <!-- TITLE -->
  <h6 class="fw-semibold text-white text-xs mb-3 d-flex align-items-center gap-2">
    <i class="fas fa-bolt text-warning fs-6"></i>
    Quick Actions
  </h6>

  <!-- ACTION GRID (Document Categories Style) -->
  <div class="row g-3">

    <!-- LOOP: ACTION CARDS -->
    <div
      v-for="(action, index) in action_items"
      :key="index"
      class="col-6 col-md-4 d-flex"
    >
      <div
        class="qa-card d-flex flex-column justify-content-center align-items-center rounded-4 p-3 w-100 text-center"
        @mouseenter="hover = index"
        @mouseleave="hover = null"
        :class="[hover === index ? 'qa-hover' : '', action.color_class]"
      >
        <!-- Icon -->
        <i :class="action.icon" class="fs-4 mb-2"></i>

        <!-- Label -->
        <p class="fw-semibold text-white text-xs mb-0">
          {{ action.label }}
        </p>

        <!-- Meta -->
        <p v-if="action.meta" class="text-white-50 text-xxs mb-0">
          {{ action.meta }}
        </p>
      </div>
    </div>

    <!-- EMERGENCY CARD -->
    <div class="col-12 col-md-4 d-flex">
      <div class="qa-card qa-danger rounded-4 p-3 w-100 text-center">

        <!-- Icon -->
        <i class="bi bi-exclamation-triangle-fill fs-4 mb-2"></i>

        <!-- Label -->
        <p class="fw-semibold text-white text-xs mb-0">
          Emergency Protocol
        </p>

      </div>
    </div>

  </div>
</div>
